import React from 'react';
import { NavLink } from 'react-router-dom';
import { companyData, navigation } from '../../data/content';
import { FiPhone, FiMapPin, FiMail } from 'react-icons/fi';
import SafeIcon from '../../common/SafeIcon';

const Footer = () => {
  // Update auf JPG Logo
  const logoUrl = "https://canv.wasacon.com/ms-terassen-de/_assets/media/321d582a486cac263b1924afe8de13f7.jpg";

  // Wir flachen die Navigation für den Footer ab, damit das Menü eine einfache Liste bleibt
  const flatNavigation = navigation.flatMap(item => item.subItems ? item.subItems : [item]);

  return (
    <footer className="bg-ms-dark text-white/70 pt-20 pb-10 border-t border-white/5">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-16">
          
          {/* Brand & Contact */}
          <div className="space-y-6">
            <NavLink to="/">
              <div className="bg-white p-2 rounded-xl inline-block">
                <img src={logoUrl} alt="Oscar Terrassen" className="h-20 w-auto object-contain" />
              </div>
            </NavLink>
            <p className="text-sm leading-relaxed font-medium">
              Ihr zertifizierter Fachbetrieb für Heinsberg und Umgebung. Wir planen, liefern und montieren Ihre Wunsch-Terrasse in Meisterqualität.
            </p>
            <div className="space-y-4 pt-2">
              <p className="flex items-start text-sm font-bold">
                <SafeIcon icon={FiMapPin} className="mt-1 mr-3 text-ms-blue flex-shrink-0" />
                {companyData.address}
              </p>
              <a href={`tel:${companyData.phone.replace(/\s/g, '')}`} className="flex items-center text-sm font-bold hover:text-ms-blue transition">
                <SafeIcon icon={FiPhone} className="mr-3 text-ms-blue flex-shrink-0" />
                {companyData.phone}
              </a>
              <a href={`mailto:${companyData.email}`} className="flex items-center text-sm font-bold hover:text-ms-blue transition">
                <SafeIcon icon={FiMail} className="mr-3 text-ms-blue flex-shrink-0" />
                {companyData.email}
              </a>
            </div>
          </div>

          {/* Navigation */}
          <div>
            <h4 className="text-white font-black uppercase tracking-widest text-sm mb-8 border-l-4 border-ms-blue pl-4">Navigation</h4>
            <ul className="space-y-3 font-bold text-sm">
              {flatNavigation.map((item) => (
                <li key={item.name}>
                  <NavLink
                    to={item.path}
                    className={({ isActive }) =>
                      `transition flex items-center ${isActive ? 'text-ms-blue' : 'hover:text-ms-blue'}`
                    }
                  >
                    {({ isActive }) => (
                      <>
                        <span className={`w-1.5 h-1.5 bg-ms-red rounded-full mr-3 transition-opacity ${isActive ? 'opacity-100' : 'opacity-0'}`}></span>
                        {item.name}
                      </>
                    )}
                  </NavLink>
                </li>
              ))}
            </ul>
          </div>

          {/* Services */}
          <div>
            <h4 className="text-white font-black uppercase tracking-widest text-sm mb-8 border-l-4 border-ms-blue pl-4">Leistungen</h4>
            <ul className="space-y-3 font-bold text-sm">
              <li><NavLink to="/leistungen" className="hover:text-ms-blue transition">Terrassen-Systeme</NavLink></li>
              <li><NavLink to="/leistungen" className="hover:text-ms-blue transition">Polycarbonat-Dächer</NavLink></li>
              <li><NavLink to="/leistungen" className="hover:text-ms-blue transition">Sonnenschutz & Markisen</NavLink></li>
              <li><NavLink to="/leistungen" className="hover:text-ms-blue transition">Glasschiebewände</NavLink></li>
              <li><NavLink to="/leistungen" className="hover:text-ms-blue transition">LED & Beleuchtung</NavLink></li>
            </ul>
          </div>

          {/* Area */}
          <div>
            <h4 className="text-white font-black uppercase tracking-widest text-sm mb-8 border-l-4 border-ms-blue pl-4">Einzugsgebiet</h4>
            <div className="flex flex-wrap gap-2">
              {['Heinsberg', 'Aachen', 'MG', 'Erkelenz', 'Geilenkirchen', 'Hückelhoven', 'Wegberg', 'Wassenberg'].map(city => (
                <span key={city} className="bg-white/5 hover:bg-ms-blue/20 px-3 py-1.5 rounded-lg text-xs font-bold text-white transition cursor-default border border-white/10 uppercase tracking-tighter">
                  {city}
                </span>
              ))}
            </div>
            
            <div className="mt-8 p-4 bg-brand-gradient rounded-2xl text-center shadow-lg">
              <p className="text-xs font-black uppercase tracking-widest text-white/80">Jetzt Anrufen</p>
              <a href={`tel:${companyData.phone.replace(/\s/g, '')}`} className="text-lg font-black text-white hover:text-ms-light transition">
                {companyData.phone}
              </a>
            </div>
          </div>
        </div>

        <div className="border-t border-white/5 mt-20 pt-10 flex flex-col md:flex-row justify-between items-center gap-6 text-xs font-bold uppercase tracking-widest text-white/30">
          <p>&copy; {new Date().getFullYear()} {companyData.name}</p>
          <div className="flex gap-8">
            <NavLink to="/marketing-strategy" className="hover:text-ms-blue transition">Marketing Doc</NavLink>
            <NavLink to="/impressum" className="hover:text-ms-blue transition">Impressum</NavLink>
            <NavLink to="/datenschutz" className="hover:text-ms-blue transition">Datenschutz</NavLink>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;